import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

export const userApi = createApi({
  reducerPath: "adminUser",
  refetchOnFocus: true,
  refetchOnReconnect: true,
  baseQuery: fetchBaseQuery({
    baseUrl: window.location.origin,
    withCredentials: true
  }),
  endpoints: build => ({
    getUser: build.query({
      query: login => `/api/User/${login}`
    }),
    getCurrentUser: build.query({
      query: () => '/api/User/Current'
    }),
    getUsers: build.query({
      query: () => ({
        url: '/api/User/Search',
        method: 'POST'
      })
    }),
    addUser: build.mutation({
      query: newUser => ({
        url: '/api/User/',
        method: 'POST',
        body: newUser
      })
    }),
    saveUser: build.mutation({
      query: saveUser => ({
        url: '/api/User/',
        method: 'PUT',
        body: saveUser
      })
    }),
    requestPasswordReset: build.mutation({
      query: passwordResetRequest => ({
        url: '/api/User/RequestPasswordReset/',
        method: 'POST',
        body: passwordResetRequest
      })
    }),
    resetPassword: build.mutation({
      query: passwordReset => ({
        url: '/api/User/ResetPassword/',
        method: 'POST',
        body: passwordReset
      })
    })
  })
})

export const { useGetUserQuery, useGetCurrentUserQuery, useGetUsersQuery, useAddUserMutation, useSaveUserMutation, useRequestPasswordResetMutation, useResetPasswordMutation } = userApi
